import React from 'react';

interface ProgressBarProps {
  isLoading: boolean;
  className?: string;
  height?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'blue' | 'green' | 'gray';
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ 
  isLoading, 
  className = '', 
  height = 'sm',
  color = 'primary'
}) => {
  if (!isLoading) return null;

  const heightClasses = {
    sm: 'h-1',
    md: 'h-2', 
    lg: 'h-3'
  };

  const colorClasses = {
    primary: 'bg-primary-600',
    blue: 'bg-blue-600',
    green: 'bg-green-600',
    gray: 'bg-gray-600'
  };

  return (
    <div className={`w-full bg-gray-200 rounded-full overflow-hidden ${heightClasses[height]} ${className}`}>
      <div 
        className={`${colorClasses[color]} h-full rounded-full animate-pulse`}
      />
    </div>
  );
};
